import ResourcesCard from "./ResourcesCard";

export default ResourcesCard;
